<template>
    <div class="my-account">
        <!-- My Account -->
        <div class="row mb-5">
            <div class="col-sm-12 col-md-8">
                <h3 class="mb-0">My Account</h3>
                <div class="account-card">
                    <div class="row ac-header">
                        <div class="col-sm-6 col-md-6">
                            <span class="title">Name</span>
                            <span class="value">{{ user.name }}</span>
                        </div>
                        <div class="col-sm-6 col-md-6 text-right">
                            <span
                                class="action"
                                @click="openModalUser(user, 'edit', 'self')"
                            >
                                <i class="fa-solid fa-pencil"></i> EDIT
                            </span>
                        </div>
                    </div>
                    <div class="row ac-body">
                        <!-- <div class="col-sm-6 col-md-3">
                            <span class="title">Sales Accounts</span>
                            <span class="value">{{ subUsers.length }}</span>
                        </div> -->
                        <div class="col-sm-6 col-md-3">
                            <span class="title">Locations</span>
                            <span class="value">{{ locations.length }}</span>
                        </div>
                        <div class="col-sm-6 col-md-3">
                            <span class="title">Email</span>
                            <span class="value">{{ user.email }}</span>
                        </div>
                        <div class="col-sm-6 col-md-3">
                            <span class="title">Phone</span>
                            <span class="value">{{ user.phone ?? "" }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Documents -->
        <!-- <div class="row mb-5">
            <div class="col-md-8">
                <div class="d-flex align-items-center justify-content-between">
                    <h3 class="mb-0">Documents</h3>
                    <span class="add-button" @click="modalShow = !modalShow">
                        <i class="fa fa-plus-circle" aria-hidden="true"></i> ADD NEW DOCUMENT
                    </span>
                </div>
                <div class="account-card">
                    <div class="row ac-header">
                        <div class="col-sm-6 col-md-6">
                            <span class="title">Federal Firearms License (FFL)</span>
                            <span class="value">Verona Gun Safe</span>
                        </div>
                        <div class="col-sm-6 col-md-6 text-right">
                            <span class="action">
                                <span class="pl-3"><i class="fa-solid fa-pencil"></i> EDIT</span>
                                <span class="pl-3"><i class="fa fa-eye"></i> VIEW</span>
                                <span class="pl-3"><i class="fa fa-download"></i> DOWNLOAD</span>
                            </span>
                        </div>
                    </div>
                    <div class="row ac-body">
                        <div class="col-sm-8 col-md-3">
                            <span class="title">License Number</span>
                            <span class="value">8-25-003-01-7H-03874</span>
                        </div>
                        <div class="col-sm-4 col-md-3 pr-0">
                            <span class="title">Type of License</span>
                            <span class="value">01</span>
                        </div>
                        <div class="col-sm-6 col-md-3">
                            <span class="title">Expires</span>
                            <span class="value">August 1, 2022</span>
                        </div>
                        <div class="col-sm-6 col-md-3 text-right">
                            <span class="status expired">Expired</span>
                            <span class="value"></span>
                        </div>
                    </div>
                </div>
                <div class="account-card">
                    <div class="row ac-header">
                        <div class="col-sm-6 col-md-6">
                            <span class="title">Special Occupational Tax (SOT)</span>
                            <span class="value">Verona Gun Safe</span>
                        </div>
                        <div class="col-sm-6 col-md-6 text-right">
                            <span class="action">
                                <span class="pl-3"><i class="fa-solid fa-pencil"></i> EDIT</span>
                                <span class="pl-3"><i class="fa fa-eye"></i> VIEW</span>
                                <span class="pl-3"><i class="fa fa-download"></i> DOWNLOAD</span>
                            </span>
                        </div>
                    </div>
                    <div class="row ac-body">
                        <div class="col-sm-8 col-md-3">
                            <span class="title">License Number</span>
                            <span class="value">8-25-003-01-7H-03874</span>
                        </div>
                        <div class="col-sm-4 col-md-3 pr-0">
                            <span class="title">Type of License</span>
                            <span class="value">01</span>
                        </div>
                        <div class="col-sm-6 col-md-3">
                            <span class="title">Expires</span>
                            <span class="value">August 1, 2022</span>
                        </div>
                        <div class="col-sm-6 col-md-3 text-right">
                            <span class="status expired">Expired</span>
                            <span class="value"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <!-- Locations -->
        <div v-if="user.role.id == 2 || user.role.id == 3" class="row mb-5">
            <div class="col-md-8">
                <!-- <div class="d-flex align-items-center justify-content-between">
                    <h3 class="mb-0">Locations</h3>
                    <span class="add-button" @click="openModalLocation(null, 'add')">
                        <i class="fa fa-plus-circle" aria-hidden="true"></i> ADD NEW LOCATION
                    </span>
                </div> -->
                <h3 class="mb-0">Locations</h3>
                <template v-for="location in locations" :key="location.id">
                    <div class="account-card">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="row ac-header">
                                    <div class="col-sm-12 col-md-12">
                                        <span class="title">Name</span>
                                        <span class="value">{{
                                            location.name
                                        }}</span>
                                    </div>
                                    <!-- <div class="col-sm-2 col-md-6 text-right px-0">
                                        <span class="action" @click="openModalLocation(location, 'edit')">
                                            <span class="pl-3"><i class="fa-solid fa-pencil"></i> EDIT</span>
                                        </span>
                                    </div> -->
                                </div>
                                <div class="row ac-body">
                                    <div class="col-sm-12 col-md-12">
                                        <div class="row mb-2">
                                            <div class="col-sm-12 col-md-12">
                                                <span class="title"
                                                    >Address</span
                                                >
                                                <span class="value">{{
                                                    location.address ?? ""
                                                }}</span>
                                                <span class="value"
                                                    >{{ location.city ?? "" }},
                                                    {{ location.state ?? "" }},
                                                    {{
                                                        location.zip_code ?? ""
                                                    }}</span
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="row ac-body">
                                    <div class="col-sm-12 col-md-12">
                                        <div class="row">
                                            <div class="col-sm-4 col-md-4">
                                                <span class="title"
                                                    >FFL Expiry:</span
                                                >
                                            </div>
                                            <div class="col-sm-8 col-md-8">
                                                <span class="value">{{
                                                    location.ffl_expiry_date ??
                                                    ""
                                                }}</span>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-4 col-md-4">
                                                <span class="title"
                                                    >SOT Expiry:</span
                                                >
                                            </div>
                                            <div class="col-sm-8 col-md-8">
                                                <span class="value">{{
                                                    location.sot_expiry_date ??
                                                    ""
                                                }}</span>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-4 col-md-4">
                                                <span class="title"
                                                    >FFL #:</span
                                                >
                                            </div>
                                            <div class="col-sm-8 col-md-8">
                                                <span class="value">{{
                                                    location.ffl_number ?? ""
                                                }}</span>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-4 col-md-4">
                                                <span class="title"
                                                    >SOT #:</span
                                                >
                                            </div>
                                            <div class="col-sm-8 col-md-8">
                                                <span class="value">{{
                                                    location.sot_number ?? ""
                                                }}</span>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-4 col-md-4">
                                                <span class="title"
                                                    >FFL EIN:</span
                                                >
                                            </div>
                                            <div class="col-sm-8 col-md-8">
                                                <span class="value">{{
                                                    location.ffl_ein ?? ""
                                                }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <!-- Employee Dealer Accounts -->
        <div v-if="user.role.id == 2" class="row mb-5">
            <div class="col-md-8">
                <!-- <div class="d-flex align-items-center justify-content-between">
                    <h3 class="mb-0">Employee Dealer Accounts</h3>
                    <span class="add-button" @click="openModalUser(null, 'add', 'employee')">
                        <i class="fa fa-plus-circle" aria-hidden="true"></i> ADD NEW ACCOUNT
                    </span>
                </div> -->
                <div class="row ac-header">
                    <div class="col-sm-6 col-md-6">
                        <h3 class="mb-0">Employee Dealer Accounts</h3>
                    </div>
                    <div class="col-sm-6 col-md-6 text-right">
                        <span
                            class="add-button"
                            @click="openModalUser(null, 'add', 'employee')"
                        >
                            <i class="fa fa-plus-circle" aria-hidden="true"></i>
                            ADD NEW ACCOUNT
                        </span>
                    </div>
                </div>
                <template v-for="user in subUsers" :key="user.id">
                    <div class="account-card">
                        <div class="row ac-header">
                            <div class="col-sm-12 col-md-6">
                                <span class="title">Name</span>
                                <span class="value">{{ user.name }}</span>
                            </div>
                            <div class="col-sm-12 col-md-6 text-right">
                                <span
                                    class="action"
                                    @click="
                                        openModalUser(user, 'edit', 'employee')
                                    "
                                >
                                    <span class="pl-3"
                                        ><i class="fa-solid fa-pencil"></i>
                                        EDIT</span
                                    >
                                </span>
                            </div>
                        </div>
                        <div class="row ac-body">
                            <div class="col-sm-12 col-md-2">
                                <span class="title">Role</span>
                                <span class="value">{{
                                    user.role.display_name ?? ""
                                }}</span>
                            </div>
                            <div class="col-sm-12 col-md-3">
                                <span class="title"
                                    >Locations they can access</span
                                >
                                <span class="value">{{
                                    user.locations_text ?? ""
                                }}</span>
                            </div>
                            <div class="col-sm-12 col-md-2">
                                <span class="title">Phone</span>
                                <span class="value">{{
                                    user.phone ?? ""
                                }}</span>
                            </div>
                            <div class="col-sm-12 col-md-2">
                                <span class="title">Email</span>
                                <span class="value">{{
                                    user.email ?? ""
                                }}</span>
                            </div>
                            <!-- <div class="col-sm-12 col-md-2">
                                <span class="title">Role</span>
                                <span class="value">{{ user.role.display_name ?? '' }}</span>
                            </div> -->
                        </div>
                    </div>
                </template>
            </div>
        </div>

        <!-- Add location modal -->
        <b-modal
            v-model="modalShowLocation"
            :title="modalType == 'add' ? 'ADD NEW LOCATION' : 'EDIT LOCATION'"
            hide-footer
        >
            <LocationModal
                v-if="modalShowLocation"
                :modal-data="modalData"
                :modal-type="modalType"
                @close-modal="closeModalLocation"
            />
        </b-modal>

        <!-- Add sub user modal -->
        <b-modal
            v-model="modalShowUser"
            :title="modalType == 'add' ? 'ADD NEW ACCOUNT' : 'EDIT ACCOUNT'"
            hide-footer
        >
            <UserModal
                v-if="modalShowUser"
                :modal-data="modalData"
                :modal-type="modalType"
                :modal-set="modalSet"
                @close-modal="closeModalUser"
            />
        </b-modal>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";

import LocationModal from "./modals/LocationModal.vue";
import UserModal from "./modals/UserModal.vue";

export default {
    props: [],
    emits: [],
    components: {
        LocationModal,
        UserModal,
    },
    setup() {
        const store = useStore();

        let user = computed(function () {
            return store.state.user;
        });
        let locations = computed(function () {
            return store.state.locations;
        });
        let subUsers = computed(function () {
            return store.state.subUsers;
        });

        function getLocations(userId) {
            store.dispatch("getLocations", { user_id: userId });
        }

        onMounted(() => {
            // store.dispatch('getLocations');
            store.dispatch("getSubUsers");
        });

        return {
            user,
            locations,
            subUsers,
            getLocations,
        };
    },
    data() {
        return {
            modalShowLocation: false,
            modalShowUser: false,
            modalType: null,
            modalSet: null,
            modalData: {},
        };
    },
    mounted() {
        this.getLocations(this.user.id);
    },
    methods: {
        openModalLocation(data, val) {
            this.modalType = val;
            this.modalData = data;
            this.modalShowLocation = !this.modalShowLocation;
        },
        openModalUser(data, val, set) {
            this.modalType = val;
            this.modalSet = set;
            this.modalData = data;
            // this.modalSalesRepId = this.user.sales_rep_id;
            this.modalShowUser = !this.modalShowUser;
        },
        closeModalLocation() {
            this.modalShowLocation = !this.modalShowLocation;
        },
        closeModalUser() {
            this.modalShowUser = !this.modalShowUser;
        },
    },
};
</script>
